<button
	class="group block w-full cursor-pointer card card-xs text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
	data-test-id="filter-map-button"
	type="button"
>
	<span
		class="flex aspect-video items-center justify-center card-image bg-[url('/assets/images/misc/map-bg.png')] bg-cover bg-center"
	>
		<span class="btn btn-neutral btn-group-hover">
			<svg-icon
				class="pointer-events-none size-4 grow-0"
				src="assets/icons/icon-map.svg"
			/>
			{{ 'compositions.filters.show-map' | translate }}
		</span>
	</span>
</button>
